<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
      <div class="footer-build">
      <p :class="build_version">Build {{ build_version }}</p>
    </div>
    </footer>
</template>

<script>

export default {
  name: 'the-footer',
  props: { 
    classes: {
      type: String
    },
    build_version:{
      type:String
    }
  },
  mounted(){
    console.log('this.build_version',this.build_version)
  }
  
}
</script>
